import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent, type AccentKey } from './theme';

export interface ValueItem {
  icon: string;
  title: string;
  desc: string;
}

interface SolutionValuesProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  items: ValueItem[];
  accentKey: AccentKey;
}

export default function SolutionValues({
  eyebrow,
  title,
  subtitle,
  items,
  accentKey,
}: SolutionValuesProps) {
  const a = accent(accentKey);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {items.map((item) => (
              <div
                key={item.title}
                className="p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className={`w-14 h-14 flex items-center justify-center rounded-full ${a.iconBox} shrink-0`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-xl leading-snug">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}